'use client';
import dynamic from 'next/dynamic';

import { useLiveOpsControl } from '~features/tags/hooks/useLiveOpsControl';
import type { RetentionBannerPlacement } from '~shared/api/retention/types';

import { useGetRetentionBanner } from '../../hooks/useGetRetentionBanner';

const MarkupBanner = dynamic(
	() => import('../MarkupBanner').then((module) => module.MarkupBanner),
	{
		ssr: false,
		loading: () => null,
	}
);

type Props = {
	placement: RetentionBannerPlacement;
	onClose?: (bannerId: string) => void;
	scrollEnabled?: boolean;
};

export const AbstractBanner = (props: Props) => {
	const [isLiveOpsGlobalControl, isLoading] = useLiveOpsControl();

	if (isLoading || isLiveOpsGlobalControl) {
		return null;
	}

	return <DataLayer {...props} />;
};

const DataLayer = ({ placement, onClose, scrollEnabled }: Props) => {
	const data = useGetRetentionBanner(placement);

	if (data.status !== 'ready') {
		return null;
	}

	return (
		<MarkupBanner
			banners={data.banners}
			onClose={onClose}
			scrollEnabled={scrollEnabled}
		/>
	);
};
